import { isAfter, isEqual } from "date-fns";

// TIP-554 — pick the subscription row the billing active-plan card shows.
//
// A paid 'verified' (membership) row always beats the signup freemium row:
// users who bought membership before the backend started deactivating
// freemium (TIP-554 backend fix) have BOTH rows active, and the freemium
// one (older, first in API order) used to win — so the card showed
// "Freemium $0 per month" right after a membership purchase.
//
// Pay-as-you-go rows are never the active plan (they are one-off credit
// purchases), and rows past their date_of_end don't count as active.
export const isCurrentlyActive = (sub, today) =>
  sub?.status === "active" &&
  sub?.subscription_type !== "pay-as-you-go" &&
  (isAfter(new Date(sub.date_of_end), today) || isEqual(new Date(sub.date_of_end), today));

export const pickActiveSub = (subs, today) =>
  subs?.find((sub) => isCurrentlyActive(sub, today) && sub?.subscription_type === "verified") ||
  subs?.find((sub) => isCurrentlyActive(sub, today));
